export default __webpack_public_path__ + "static/media/metamask-fox.799d16ac.svg";